<template>
  <div>
    <div v-if="errorCode === 404" class="receiptsNotFound">
      <div>
        <strong>QR-код</strong> не дійсний,<br />
        зверніться до офіціанта для здійснення оплати
      </div>
    </div>

    <div v-else-if="errorCode === 410" class="receiptsNotFound">
      <div>
        <img class="dino" src="./surprise.svg" />
        <div class="title_Eror">Помилка</div>
        <div style="padding: 0 15px; opacity: 0.6; font-size: 18px">
          Платіж не вдалося обробити через помилку сервісу оплати
        </div>
        <button
          @click="onRefresh"
          style="margin-top: 10px"
          class="btn btn-warning"
        >
          Оновити
        </button>
      </div>
    </div>

    <div v-else-if="errorCode === 1001" class="receiptsNotFound">
      <div>
        <img class="dino" src="./surprise.svg" />
        <div class="title_Eror">Помилка</div>
        <div style="opacity: 0.6; font-size: 18px">
          З'єднання із закладом втрачено.<br />
          Зверніться до адміністратора.
        </div>
        <button
          @click="onRefresh"
          style="margin-top: 10px"
          class="btn btn-warning"
        >
          Оновити
        </button>
      </div>
    </div>

    <div v-else-if="errorCode === 1002" class="receiptsNotFound">
      <div>
        <strong>Помилка оплати</strong><br />
        Зверніться до адміністратора.
      </div>
    </div>

    <div v-else-if="errorCode === 400" class="receiptsNotFound">
      <div>
        <div>Рахунків для оплати не знайдено</div>
        <button
          @click="onRefresh"
          style="margin-top: 10px"
          class="btn btn-warning"
        >
          Оновити
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["errorCode", "onRefresh"],
  data() {
    return {};
  },
  components: {},
  computed: {},
};
</script>

<style>
.dino {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}
</style>
